import React from 'react'
import style from './Infobar.module.scss'

// get infobar with spot name
function Infobar({ handData }) {
    return <div className={style.InfoBar}>{handData.spotName}</div>
}

export default Infobar
